/* ========== *
 * READ media *
 * ========== */

import { axiosInstance } from '@/utils/lib/axios'
import { useMutation } from '@tanstack/react-query'

interface MediaDownloadTarget {
  path: string
  fileName: string
}

async function downloadMedia(target: MediaDownloadTarget): Promise<void> {
  const { path, fileName } = target

  try {
    const response = await axiosInstance.get(
      `/api/media/download-disk?path=${path}${fileName ? '&fileName=' + fileName : ''}`,
      {
        responseType: 'blob',
      },
    )

    const blob = new Blob([response.data])
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download failed:', error)
    throw error
  }
}

// Using mutation for simplicity in downloading file.
// Ref: https://github.com/TanStack/query/discussions/3105#discussioncomment-1833920
function useMediaDownload() {
  return useMutation({
    mutationFn: downloadMedia,
  })
}

export type { MediaDownloadTarget }
export { useMediaDownload }
